import type { TemplateOnlyComponent } from '@ember/component/template-only';

interface CoachingSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

const ProgramsProgramCohortCoachingTemplate: TemplateOnlyComponent<CoachingSignature> =
  <template>{{outlet}}</template>;

export default ProgramsProgramCohortCoachingTemplate;
